import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const GestureTouch = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M24 28H11C9.275 28 8.15 26.913 7.763 26.262C7.738 26.212 7.713 26.162 7.688 26.112L4.3 17.537C4.087 17.049 3.987 16.525 3.987 15.987C3.987 13.787 5.787 11.987 7.987 11.987C8.699 11.987 9.387 12.162 9.987 12.462V7.99896C9.987 5.83696 11.749 4.03596 13.912 3.99896C14.975 3.98596 15.987 4.38696 16.762 5.14896C17.55 5.91196 17.987 6.98696 17.987 8.07396V12.187L23.962 13.387C26.287 13.85 27.987 15.912 27.987 18.287V23.999C27.999 26.199 26.199 27.999 23.999 27.999L24 28ZM9.512 25.275C9.649 25.45 10.137 26 11 26H24C25.1 26 26 25.1 26 24V18.275C26 16.85 24.988 15.613 23.587 15.337L16.799 13.974C16.337 13.886 15.999 13.474 15.999 12.999V8.06096C15.999 7.49796 15.774 6.96096 15.362 6.56096C14.975 6.18596 14.475 5.98596 13.95 5.98596C12.875 6.02296 12 6.91096 12 7.99896V18.999C12 19.549 11.55 19.999 11 19.999C10.45 19.999 10 19.549 10 18.999V15.186C9.7 14.498 8.863 13.998 8 13.998C6.9 13.998 6 14.898 6 15.998C6 16.273 6.05 16.536 6.162 16.773C6.162 16.785 6.175 16.785 6.175 16.798L9.512 25.273V25.275Z" />
	</svg>
);

export default GestureTouch;
